import { Routes } from '@angular/router';
import { auth as authGuard } from 'oneok/customer-portal/customer/auth.guard';
import { ViewHelp, ViewInterested, ViewSession } from 'oneok/customer-portal/views';
import { LoginView, ProfileView, RegisterView } from '@customer/contact';
import { ViewOnboard } from '@customer/account/onboard';
import { externalAdminGuard } from '@customer/admin';
import { redirect as redirectGuard } from '@core/guards/redirect.guard';
import { gatheringAndProcessing as gatheringAndProcessingGuard } from '@nggp/gathering-and-processing.guard';
import { intrastatePipelines as intrastatePipelinesGuard } from '@ngp/intrastate/intrastate-pipelines.guard';

export const BASE_ROUTES: Routes = [
  { path: 'login', component: LoginView },
  { path: 'register/:invitationId', component: RegisterView },
  { path: 'interested', component: ViewInterested },
  { path: 'onboard', component: ViewOnboard },
  { path: 'session', component: ViewSession },
  /**
   * Authenticated routes
   */
  { path: 'profile', canMatch: [authGuard], component: ProfileView },
  { path: 'help', canMatch: [authGuard], component: ViewHelp },
  {
    path: 'admin',
    canMatch: [authGuard, externalAdminGuard],
    loadComponent: () => import('../customer/admin').then(({ ViewAdmin: view }) => view)
  },
  // NGGP routes
  {
    path: 'gathering-and-processing',
    canMatch: [authGuard, gatheringAndProcessingGuard],
    loadChildren: () => import('@nggp/routes'),
    data: {
      vertical: 'Natural Gas',
      segment: 'Gathering & Processing'
    }
  },
  // NGP routes
  {
    path: 'intrastate-pipelines',
    canMatch: [authGuard, intrastatePipelinesGuard],
    loadChildren: () => import('@ngp/intrastate/routes'),
    data: {
      vertical: 'Natural Gas',
      segment: 'Intrastate Pipelines'
    }
  },
  // Wildcard(s)
  { path: '**', pathMatch: 'full', children: [], canMatch: [redirectGuard] }
];
